function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import PropTypes from "prop-types";
import { Component, cloneElement } from "react";
import DropdownReactContext from "./DropdownReactContext";
export const DropdownSourceRef = "DropdownSource";
export default class DropdownSource extends Component {
  render() {
    const {
      children,
      ...rest
    } = this.props;
    return /*#__PURE__*/cloneElement(children, {
      ...rest,
      onRequestCloseDropdown: this.context.closeDropdown
    });
  }
}
_defineProperty(DropdownSource, "contextType", DropdownReactContext);
_defineProperty(DropdownSource, "typeRef", DropdownSourceRef);